import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  /* Import gaming fonts from Google Fonts */
  @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;500;600;700;800&family=Poppins:wght@300;400;500;600;700&display=swap');

  /* Reset and base styles */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: ${props => props.theme.fonts.primary};
    background-color: ${props => props.theme.colors.background.primary};
    color: ${props => props.theme.colors.text.primary};
    line-height: 1.6;
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${props => props.theme.fonts.heading};
    font-weight: ${props => props.theme.fontWeights.bold};
    line-height: 1.2;
    margin-bottom: ${props => props.theme.spacing.medium};
  }

  h1 {
    font-size: ${props => props.theme.fontSizes.hero};

    @media (max-width: ${props => props.theme.breakpoints.tablet}) {
      font-size: 2.5rem;
    }

    @media (max-width: ${props => props.theme.breakpoints.mobile}) {
      font-size: 2rem;
    }
  }

  h2 {
    font-size: ${props => props.theme.fontSizes.xxlarge};
  }

  h3 {
    font-size: ${props => props.theme.fontSizes.xlarge};
  }

  p {
    margin-bottom: ${props => props.theme.spacing.medium};
  }

  a {
    color: ${props => props.theme.colors.primary};
    text-decoration: none;
    transition: color ${props => props.theme.transitions.fast};

    &:hover {
      color: ${props => props.theme.colors.primaryLight};
    }
  }

  button {
    font-family: ${props => props.theme.fonts.primary};
    cursor: pointer;
    border: none;
    outline: none;
    transition: all ${props => props.theme.transitions.medium};
  }

  /* Scrollbar styling - Gaming theme */
  ::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }

  ::-webkit-scrollbar-track {
    background: ${props => props.theme.colors.background.secondary};
  }

  ::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.primary};
    border-radius: ${props => props.theme.borderRadius.medium};

    &:hover {
      background: ${props => props.theme.colors.primaryLight};
    }
  }

  /* Selection color */
  ::selection {
    background-color: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.background.primary};
  }

  ::-moz-selection {
    background-color: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.background.primary};
  }

  /* Utility classes */
  .container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 ${props => props.theme.spacing.large};

    @media (max-width: ${props => props.theme.breakpoints.tablet}) {
      padding: 0 ${props => props.theme.spacing.medium};
    }
  }

  .text-center {
    text-align: center;
  }

  .text-gradient {
    background: linear-gradient(135deg, ${props => props.theme.colors.primary} 0%, ${props => props.theme.colors.neon.cyan} 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  /* Gaming glow animation */
  @keyframes glow {
    0%, 100% {
      filter: drop-shadow(0 0 5px ${props => props.theme.colors.primary});
    }
    50% {
      filter: drop-shadow(0 0 20px ${props => props.theme.colors.primary});
    }
  }

  .glow-effect {
    animation: glow 2s ease-in-out infinite;
  }

  /* Panning animation for background */
  @keyframes animate-left-to-right {
    from {
      background-position: 0 0;
    }
    to {
      background-position: 100% 0;
    }
  }

  /* Fade in animation */
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .fade-in {
    animation: fadeIn 0.8s ease-out;
  }

  /* Loading spinner */
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
